import { useMutation } from "@tanstack/react-query";
import { CreateComment } from "../types/Comment";
import { createComment, updateComment } from "./comments.service";

export const useCreateComment = () => {
  return useMutation({
    mutationFn: (comment: CreateComment) => createComment(comment),
  });
};

export const useUpdateComment = () => {
  return useMutation({
    mutationFn: (data: {
      taskId: string;
      commentId: string;
      updates: Partial<Pick<CreateComment, "text" | "images">>;
    }) => updateComment(data.commentId, data.updates),
  });
};
